const autocompleteFormService = {
  places: 'Local',
  equipments: 'Equipamento (primeiros 50 resultados)',
  serviceType: 'Tipo do Serviço',
  latitude: 'Latitude',
  longitude: 'Longitude',
  noAuthorization: 'Sem autorização',
};

export default autocompleteFormService;
